import { render } from "./FeaturesDialog.vue?vue&type=template&id=062c5c8e&scoped=true&ts=true"
import script from "./FeaturesDialog.vue?vue&type=script&lang=ts"
export * from "./FeaturesDialog.vue?vue&type=script&lang=ts"

import "./FeaturesDialog.vue?vue&type=style&index=0&id=062c5c8e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062c5c8e"]])

export default __exports__